import '../css/app.scss';

// Configuration for snowfall effect
let snowflakeCount = window.innerWidth <= 768 ? 30 : 100; // Менше сніжинок для мобільних
const snowflakeSymbols = ['❄', '❅', '❆', '.']; // Different snowflake symbols for variety

// Function to generate a random number between min and max
function random(min, max) {
    return Math.random() * (max - min) + min;
}

// Function to create a single snowflake element
function createSnowflake() {
    const snowflake = document.createElement('div');
    snowflake.classList.add('snowflake');
    snowflake.innerText = snowflakeSymbols[Math.floor(Math.random() * snowflakeSymbols.length)];
    snowflake.style.left = `${random(0, 100)}vw`; // Random horizontal position
    snowflake.style.fontSize = `${random(0.8, 2)}em`; // Random size for variety
    snowflake.style.opacity = random(0.5, 1); // Random opacity for a more natural look

    // Animation properties for falling and drifting
    snowflake.style.animationDuration = `${random(10, 30)}s`; // Random fall speed
    snowflake.style.animationDelay = `${random(0, 15)}s`; // Random start delay
    snowflake.style.setProperty('--horizontal-drift', `${random(-15, 15)}vw`); // Slight horizontal drift
    snowflake.style.setProperty('--rotation', `${random(-360, 360)}deg`); // Random rotation for each flake

    // Randomly add lens flare effect to some snowflakes
    if (Math.random() > 0.8) {
        snowflake.classList.add('flare');
    }

    // Randomly blur some snowflakes to add depth
    if (Math.random() > 0.5) {
        snowflake.classList.add('blurred');
    }

    document.body.appendChild(snowflake);

    // Remove snowflake after it falls out of view
    snowflake.addEventListener('animationend', () => {
        snowflake.remove();
    });
}

// Generate multiple snowflakes initially
for (let i = 0; i < snowflakeCount; i++) {
    createSnowflake();
}

// Generate new snowflakes continuously for an ongoing effect
setInterval(() => {
    if (document.querySelectorAll('.snowflake').length < snowflakeCount) {
        createSnowflake();
    }
}, 500);

// Adjust snowflake count on window resize
window.addEventListener('resize', () => {
    snowflakeCount = window.innerWidth <= 768 ? 30 : 100; // Update for mobile or desktop
});


document.addEventListener('DOMContentLoaded', () => {
    // Перехід між секціями hero → works → quiz
    const heroBtn = document.querySelector('.hero__btn');
    const worksBtn = document.querySelector('.works__btn');

    if (heroBtn) {
        heroBtn.addEventListener('click', () => {
            document.querySelector('.hero').classList.add('hidden-block');
            document.querySelector('.works').classList.remove('hidden-block');
        });
    }

    if (worksBtn) {
        worksBtn.addEventListener('click', () => {
            document.querySelector('.works').classList.add('hidden-block');
            document.querySelector('.quiz').classList.remove('hidden-block');
        });
    }

    // Перехід між блоками quiz__section з валідацією
    const quizButtons = document.querySelectorAll('.quiz__btn');

    quizButtons.forEach(button => {
        button.addEventListener('click', () => {
            const currentSection = button.closest('.quiz__section');

            // Перевірка заповнення полів
            if (!validateSection(currentSection)) {
                handleResponseOutput(currentSection, 'Please fill in all required fields.');
                return; // Зупиняємо перемикання
            }

            // Ховаємо будь-які попередні повідомлення помилок
            clearResponseOutput(currentSection);

            const allSections = document.querySelectorAll('.quiz__section');
            const currentIndex = Array.from(allSections).indexOf(currentSection);

            // Отримуємо наступний блок за індексом
            const nextSection = allSections[currentIndex + 1];

            if (nextSection) {
                currentSection.classList.add('hidden-block'); // Ховаємо поточний блок
                nextSection.classList.remove('hidden-block'); // Відображаємо наступний блок
            }
        });
    });

    // Логіка для "Thank You" блоку після відправлення форми
    document.addEventListener('wpcf7mailsent', function (event) {
        const thankYouSection = document.querySelector('.quiz__section-thankyou');
        const formSection = document.querySelector('.quiz__section-last');

        if (thankYouSection) {
            thankYouSection.classList.remove('hidden-block'); // Показуємо "Thank You" блок
        }

        if (formSection) {
            formSection.classList.add('hidden-block'); // Ховаємо форму
        }
    });

    // Логіка для відображення повідомлення про помилку
    document.addEventListener('wpcf7mailfailed', function (event) {
        const responseOutput = event.target.querySelector('.wpcf7-response-output');
        if (responseOutput) {
            responseOutput.style.display = 'block'; // Відображаємо блок із повідомленням
        }
    });

    // Функція перевірки полів у секції
    function validateSection(section) {
        let isValid = true;

        // Перевірка текстових полів (ім'я та email)
        const inputs = section.querySelectorAll('input[type="text"], input[type="email"]');
        inputs.forEach(input => {
            if (!input.value.trim()) {
                isValid = false; // Поле порожнє
                input.classList.add('invalid'); // Додаємо візуальну індикацію
            } else {
                input.classList.remove('invalid');
            }
        });

        // Перевірка радіокнопок (одна повинна бути обрана)
        const radioGroups = section.querySelectorAll('input[type="radio"]');
        if (radioGroups.length > 0) {
            const radios = Array.from(radioGroups);
            const isChecked = radios.some(radio => radio.checked);
            if (!isChecked) {
                isValid = false; // Жодне радіо не обране
                radios.forEach(radio => {
                    radio.closest('.quiz__label').classList.add('invalid');
                });
            } else {
                radios.forEach(radio => {
                    radio.closest('.quiz__label').classList.remove('invalid');
                });
            }
        }

        return isValid;
    }

    // Функція для відображення повідомлення в .wpcf7-response-output
    function handleResponseOutput(section, message) {
        const responseOutput = section.querySelector('.wpcf7-response-output');
        if (responseOutput) {
            responseOutput.style.display = 'block';
            responseOutput.textContent = message;
        }
    }

    // Функція для очищення повідомлень у .wpcf7-response-output
    function clearResponseOutput(section) {
        const responseOutput = section.querySelector('.wpcf7-response-output');
        if (responseOutput) {
            responseOutput.style.display = 'none';
            responseOutput.textContent = '';
        }
    }
});
